import React, { useState } from 'react';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import { WpButton, Variant } from 'Wpds/components/button';
import { WpFormLayout } from 'Wpds/components/form';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './CustomGPT3Attributes.scss';

type Props = {
  handleAddCustomAttribute: Function;
  placeholder: string;
  inputId: string;
  label: string;
  buttonVariant?: Variant;
};

const CustomGPT3Attributes = ({
  handleAddCustomAttribute,
  placeholder,
  inputId,
  label,
  buttonVariant = 'secondary',
}: Props) => {
  const [isShowingInput, toggleIsShowingInput] = useToggle(false);
  const [value, setValue] = useState('');

  const handleAddClick = () => {
    if (!value) return null;
    handleAddCustomAttribute(value);
    setValue('');
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    const { key } = event;
    if (key === 'Enter') {
      handleAddClick();
      event.preventDefault();
    }
  };

  const baseClassName = 'CustomGPT3Attributes';

  return (
    <div className={baseClassName}>
      {isShowingInput && (
        <WpFormLayout direction="horizontal">
          <WpTextField
            id={inputId}
            label={label}
            value={value}
            onChange={setValue}
            labelHidden
            max={25}
            placeholder={placeholder}
            autoFocus
            onKeyPress={handleKeyPress}
          />
          <WpButton size="lg" onClick={handleAddClick}>
            Add
          </WpButton>
        </WpFormLayout>
      )}

      {!isShowingInput && (
        <WpButton variant={buttonVariant} onClick={toggleIsShowingInput}>
          <WpIcon name="plus-circle" />
          Add your own
        </WpButton>
      )}
    </div>
  );
};

export default CustomGPT3Attributes;
